// extracted by mini-css-extract-plugin
export default {"link":"nav-item_link__OgrXI text_type_main-default p-5 mr-2","linkActive":"nav-item_linkActive__wTqbd","description":"nav-item_description__-+JLd ml-2"};